import { checkEnterpriseId, getResponseData } from "@helpers/_functions";
import http from "../http-common";
import BaseService from "./base.service";

class TimeBankSettingService extends BaseService {
  constructor() {
    super("time-bank-setting");
  }

  get() {
    const enterpriseId = checkEnterpriseId();
    return http
      .get(`${this.path}/${enterpriseId}`)
      .then((response) => getResponseData(response));
  }

  upsert(data) {
    const enterpriseId = checkEnterpriseId();
    return http
      .put(`${this.path}/${enterpriseId}`, data)
      .then((response) => getResponseData(response));
  }
}

export default new TimeBankSettingService();
